<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-container>
      <v-stepper v-model="activeStep">
        <v-stepper-header>
          <v-stepper-step :complete="activeStep > 1" step="1">
            Tell us about yourself
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="activeStep > 2" step="2">
            When do you want your battery
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3">
            Choose your battery
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  label="Full Name"
                  v-model="formValues.name"
                  :rules="[$validation.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  label="Email"
                  v-model="formValues.email"
                  :rules="[$validation.required, $validation.email]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  label="Phone"
                  v-model="formValues.phone"
                  :rules="[$validation.required, $validation.phone]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card class="mb-12" color="grey lighten-1" height="200px"></v-card>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-row v-if="activeStep === 3">
              <v-col cols="12" md="4">
                <v-select
                  v-model="selectedMake"
                  :items="makes"
                  label="Make *"
                  outlined
                  :rules="[$validation.required]"
                  required
                  item-text="make"
                  :item-value="itemValue"
                  hide-details
                  @change="handleMake"
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-select
                  v-model="selectedModel"
                  :items="models"
                  label="Model *"
                  outlined
                  :rules="[$validation.required]"
                  required
                  item-text="title"
                  :item-value="itemValue"
                  hide-details
                  @change="handleModel"
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-select
                  v-model="selectedWarranty"
                  :items="warranties"
                  label="Warranty *"
                  outlined
                  :rules="[$validation.required]"
                  required
                  item-text="warranty"
                  :item-value="itemValue"
                  hide-details
                  @change="handleWarranty"
                >
                  <template slot="item" scope="data">
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.warranty" />
                      <v-list-item-subtitle v-html="data.item.type" />
                    </v-list-item-content>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-switch
                  v-model="requireInstallation"
                  label="Require installation"
                  @change="handleInstallation"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-switch
                  v-model="ccpayment"
                  label="Credit Card Payment"
                  @change="handlePayment"
                />
              </v-col>
            </v-row>
          </v-stepper-content>
          <v-btn text @click="stepper(-1)" v-if="activeStep > 1">Prev</v-btn>
          <v-btn
            color="primary"
            @click="stepper(1)"
            v-if="activeStep < 3"
          >
            Next
          </v-btn>
          <v-btn color="primary" v-if="activeStep === 3" @click="submit">
            Submit
          </v-btn>
        </v-stepper-items>
      </v-stepper>

      <v-row>
        <v-col
          cols="12"
          md="4"
          :key="`price-${price.id}-${i}`"
          v-for="(price, i) in priceList"
        >
          <v-card>
            <v-card-title>{{ price.make }}</v-card-title>
            <v-card-subtitle
              >{{ price.warranty.replace("unlimited mileage warranty", "") }} ({{
                price.warrantyType
              }})</v-card-subtitle
            >
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr v-for="item in billItems" :key="item.name">
                    <td>{{ item.name }}</td>
                    <td>{{ price[item.value] }}</td>
                  </tr>
                  <tr>
                    <th>Total</th>
                    <th>{{ price.total }}</th>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import batteriesV2 from "@/data/batteries_v2.json";
import { getOfficeTaxRate } from "../utils/officeLocation";

function distanceCost(distance) {
  let cost = 0;
  if (distance > 100) {
    cost = parseInt(distance);
  } else if (distance > 75) {
    cost = 95;
  } else if (distance > 50) {
    cost = 50;
  } else if (distance > 0) {
    cost = 25;
  }
  return cost;
}

function getInstallationCost(model) {
  let cost = 0;
  if (model && model.installation) {
    cost = parseInt(model.installation.replace(/^\D+/g, "")) || 0;
  }
  // console.log('getInstallationCost', model)
  return cost;
}

function getTax(warranty, model, taxRate) {
  let partCost = 0;
  let tax = 0;
  if (warranty && warranty.cost) {
    partCost = parseFloat(warranty.cost.replace(/[,$]/g, ""));
  }
  if (!model.installation.includes("tax included")) {
    tax = parseFloat((partCost * taxRate).toFixed(2));
  }
  return { partCost, tax };
}

export default {
  name: "booking-form",
  data() {
    return {
      formValues: {
        name: "",
        email: "",
        phone: "",
        date: "",
        time: ""
      },
      valid: true,
      activeStep: 1,
      options: {},
      selectedMake: "",
      selectedModel: "",
      selectedWarranty: "",
      requireInstallation: true,
      ccpayment: false,
      total: 0,
      travelDistance: null,
      makes: [],
      models: [],
      warranties: [],
      taxRate: "",
      priceList: [],
      billItems: [
        {
          name: "Battery Cost",
          value: "batteryCost"
        },
        {
          name: "Sales Tax",
          value: "tax"
        },
        // {
        //   name: 'To',
        //   value: 'total',
        // },
        {
          name: "Installation Cost",
          value: "installationCost"
        },
        {
          name: "Mobile Service",
          value: "distanceCost"
        },
        {
          name: "Credit Card Charges",
          value: "cccharges",
          interpolate: item => item.cccharges
        }
      ]
    };
  },
  async mounted() {
    const location = this.selectedLocation;
    this.taxRate = await getOfficeTaxRate(location);
    this.makes = batteriesV2;
  },
  methods: {
    itemValue(item) {
      return item;
    },
    handleMake(item) {
      this.models = item.models || [];
      this.selectedModel = "";
      this.selectedWarranty = "";
    },
    handleModel(item) {
      this.warranties = item.batteries || [];
      this.selectedWarranty = "";
      this.calculateTotal();
      this.updatePricing();
    },
    handleWarranty() {
      this.calculateTotal();
      this.updatePricing();
    },
    handleDistance() {
      this.calculateTotal();
      this.updatePricing();
    },
    handleInstallation() {
      this.calculateTotal();
      this.updatePricing();
    },
    handlePayment() {
      this.calculateTotal();
      this.updatePricing();
    },
    calculateTotal() {
      let total = 0;
      const dcost = distanceCost(this.travelDistance);
      const installationCost = this.requireInstallation
        ? getInstallationCost(this.selectedModel)
        : 0;
      const taxRate = this.taxRate / 100;
      const { partCost, tax } = getTax(
        this.selectedWarranty,
        this.selectedModel,
        taxRate
      );
      total = dcost + installationCost + partCost + tax;

      if (this.ccpayment) {
        const cccharges = parseFloat((total * 0.03).toFixed(2));
        total += cccharges;
      }
      this.total = total;
    },
    updatePricing() {
      const priceList = [];
      if (this.selectedWarranty) {
        priceList.push(this.getWarrantyPrice(this.selectedWarranty));
      } else {
        // this.warranties.forEach(item => {
        //   priceList.push(this.getWarrantyPrice(item));
        // });
      }
      this.priceList = priceList;
    },
    getWarrantyPrice(item) {
      const dcost = distanceCost(this.travelDistance);
      const installationCost = this.requireInstallation
        ? getInstallationCost(this.selectedModel)
        : 0;

      let total = 0,
        cccharges = 0;
      const taxRate = this.taxRate / 100;
      const { partCost, tax } = getTax(item, this.selectedModel, taxRate);
      // if(item && item.cost) {
      //   batteryCost = parseFloat(item.cost.replace(/[,$]/g, ''));
      //   const taxRate = this.taxRate / 100;
      //   tax = parseFloat((batteryCost * taxRate).toFixed(2));
      // }
      total = dcost + installationCost + partCost + tax;
      if (this.ccpayment) {
        cccharges = parseFloat((total * 0.03).toFixed(2));
      }
      total += cccharges;
      return {
        id: new Date().getTime(),
        make: this.selectedModel.title,
        warranty: item.warranty,
        warrantyType: item.type,
        batteryCost: partCost,
        tax,
        cccharges,
        total,
        installationCost,
        distanceCost: dcost
      };
    },
    validate() {
      return this.$refs.form.validate();
    },
    stepper(step) {
      if(step > 0 && !this.validate()) return;
      this.activeStep += step;
    },
    submit() {
      if(!this.validate()) return;
    }
  }
};
</script>
